// A10 — THE IMPORT CELL RESOLVER. Brief 65 (brief 50 §4), the ninth of the sixteen.
//
// One spreadsheet cell that is supposed to name a taxonomy entry: resolve it,
// note what happened in the run's vocabulary report, hand back the value. Four
// copies, and two of the pairs are byte-identical:
//
//   CaseView.tsx:243-252@8fdbbd6c x CollectiveCaseView.tsx:492-501@8fdbbd6c   100.0%
//   CollectiveCaseView.tsx:492-501@8fdbbd6c x :1809-1818@8fdbbd6c             100.0%
//   src/App.tsx:930-939@8fdbbd6c x each of the three                           91.3%
//
// THE ONLY DIFFERENCE IS ONE PARAMETER'S TYPE, and the union rule decides it
// rather than a preference: three copies declare `excelRow: number | string`
// and App's declares `number`. Rule 2 says the extracted helper takes what
// every call site actually passes, so it takes the wider one. Narrowing to
// `number` would have been selecting.
//
// ── THE `.mjs` BOUNDARY IS NOT CROSSED, and that is checked rather than assumed
//
// Brief 50 §5: "do not move code across the `.mjs` boundary until those thirteen
// are typed". They are not typed — `tsconfig.json` still sets `checkJs: false`
// and none of the 13 `src/lib/*.mjs` carries `@ts-check`. This move does not
// cross it: the code goes from `.tsx` to `.ts`, both on the same side, and the
// unchecked join into `importVocabulary.mjs` is exactly the join it already
// was. What changes is its width — FOUR unchecked call sites become ONE.
import { resolveImportCell } from "./importVocabulary.mjs";
import type { TaxList } from "./taxonomyTypes";

// The report is the run's, so the resolver is made per run and closes over it —
// which is what all four copies did, each closing over its own `vocabReport`.
export function makeImportCell(vocabReport: {
  note: (
    kind: string,
    raw: string,
    state: unknown,
    excelRow: number | string,
  ) => void;
}) {
  return (
    kind: string,
    entries: TaxList,
    raw: unknown,
    excelRow: number | string,
  ) => {
    const r = resolveImportCell(raw, entries);
    vocabReport.note(kind, String(raw ?? "").trim(), r.state, excelRow);
    return r.value;
  };
}
